import { createFileRoute } from '@tanstack/react-router';
import { parse, object, string, optional } from 'valibot';

export const Route = createFileRoute('/(authenticated)/patients/$patientId/care-plan')({
	validateSearch: (search) =>
		parse(
			object({
				condition: optional(string()),
				goal: optional(string()),
			}),
			search,
		),
});
